import { GetLocaleTextParams, GridOptions } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

export function useTranslatedGridLocaleText() {
  const { t } = useTranslation();

  const getLocaleText: GridOptions['getLocaleText'] = (
    params: GetLocaleTextParams<any, any>
  ) => {
    const i18Key = `common.grid.${params.key}`;
    const tl = t(i18Key);
    return tl === i18Key ? params.defaultValue : tl;
  };

  return { getLocaleText } as const;
}
